import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

// components
// import SearchInput from "components/LibraryComponents/Components/SearchInput/SearchInput";
import SearchInput from "components/LibraryComponents/Components/SearchInput";
import SamEntityTable from "components/SamEntityTable/SamEntityTable";
import TableSkeleton from "components/SamEntityTable/TableSkeleton";
import NoSAMResultFound from "components/NoSAMResultFound/NoSAMResultFound";
import { Alert } from "@trussworks/react-uswds";

// store
import { useSamEntityStore } from "store/useSamEntityStore";
import useAuthStore from "store/useAuthStore";

// query
import { useSamEntitySearch } from "./query";

// styles
import styles from './SamEntitySearch.module.scss';

export default function SamEntitySearch() {

	const { user } = useAuthStore();
	const navigate = useNavigate();

	// Redirect non-admin users to home
	useEffect(() => {
		if (!user || user.role !== "admin") {
			navigate("/");
		}
	}, [user, navigate]);

	const { uei, setUei } = useSamEntityStore();

  	const { data, isLoading, errorType} = useSamEntitySearch(uei);

	const showTable = uei && !isLoading && data && data.results && data.results.length > 0;

	const noResults = uei && !isLoading && data && data.results && data.results.length === 0;

	function onChange(event){
		setUei(event.target.value);
	}

	if (errorType === "NOT_AUTHORIZED") {
		return (
			<>
				<Helmet>
					<title>Not authorized | SAM Entity | SBA Small Business Search</title>
				</Helmet>
				<div className={styles["error-wrapper"]}>
					<Alert type="error" headingLevel="h6" className={styles["alert-wrapper"]}>
						<p>You are not authorized to view this. Please contact your administrator if you believe this is an error.</p>
					</Alert>
				</div>
			</>
		);
	}

	return (
		<div className={styles["sam-entity-search-root"]}>
			<Helmet>
				<title>Sam Entity Search</title>
			</Helmet>
			<h1>Sam Entity Search</h1>
			<div className={styles["input-wrapper"]}>
				<SearchInput
					value={uei}
					placeholder="Type to search for small businesses by UEI"
					handleClear={() => setUei("")}
					id="hey"
					name="n"
					onChange={onChange}
				/>
			</div>
			{isLoading && <TableSkeleton />}
			{showTable && <SamEntityTable data={data.results} />}
			{noResults && <NoSAMResultFound content="Please try another UEI" />}
		</div>
	);
}